module.exports = __webpack_public_path__ + "img/ALERT MSG.78e3fcfc.jpg";